import { ServiceRequestApi } from '../ServiceRequestApi';
import Dict from '../../../modules/utils/Dict';
import Notice from '../../../modules/utils/Notice';
import i18next from 'i18next';
import moment from 'moment';
import { handleError } from '../../../modules/utils/handleError';
import { CONTINGENT_STATUS, DIRECTION_STATUS } from '../../../_helpers/Constants';

const getFio = (item) => `${item?.childSurname || ''} ${item?.childName || ''} ${item?.childMiddleName || ''}`;

const showActiveQueueError = async (item) => {
    switch (item.appStatus) {
        case 'ON_CHECK':
            const app_status = await Dict.item('gu_app_status', item.appStatus);
            Notice.error(
                i18next.t('serviceRequest_check_in_queue_err1', {
                    fio: getFio(item),
                    child_iin: item.childIin,
                    req_form_id: item.requestFormId,
                    app_status: app_status[`${i18next.language}_name`]
                })
            );
            break;
        case 'IN_QUEUED':
        case 'WAITING_ASSIGN':
            const q_type = await Dict.item('gu_queued_type', item.queuedType);
            const p_queued = await Dict.item('gu_priority_queued', item.priorityQueued);
            Notice.error(
                i18next.t('serviceRequest_check_in_queue_err2', {
                    fio: getFio(item),
                    child_iin: item.childIin,
                    req_form_id: item.requestFormId,
                    queued_type: q_type[`${i18next.language}_name`],
                    priority_queued: p_queued[`${i18next.language}_name`]
                })
            );
            break;
        case 'ASSIGN_VOUCHER':
        case 'WAITING_CONFIRM_VOUCHER':
            Notice.error(
                i18next.t('serviceRequest_check_in_queue_err5', {
                    fio: getFio(item),
                    req_form_id: item.requestFormId,
                    child_iin: item.childIin
                })
            );
            break;
        case 'STOP_LIST_DC':
            Notice.error(
                i18next.t('serviceRequest_check_in_queue_err4', {
                    fio: getFio(item),
                    child_iin: item.childIin,
                    req_form_id: item.requestFormId,
                    deadline_stop_list: item.deadlineStopList
                        ? moment(item.deadlineStopList).format('DD.MM.YYYY')
                        : '__.__.____'
                })
            );
            break;
        case 'RECEIVED_VOUCHER':
            Notice.error(
                i18next.t('serviceRequest_check_in_queue_err6', {
                    fio: getFio(item),
                    req_form_id: item.requestFormId,
                    child_iin: item.childIin,
                    id: item.id
                })
            );
            break;
        default:
            break;
    }
};

const showContingentError = (item) => {
    switch (item.contingentStatus) {
        case DIRECTION_STATUS.ARRIVED_TO_PO:
            Notice.error(
                i18next.t('childInformationButton_arrivedDO', {
                    fio: item.childName + ' ' + item.childSurname,
                    child_iin: item.childIin
                })
            );
            break;
        case DIRECTION_STATUS.ENROLLED_TO_PO:
        case CONTINGENT_STATUS.ENROLLED:
            Notice.error(
                i18next.t('childInformationButton_enrolledDO', {
                    fio: item.childName + ' ' + item.childSurname,
                    child_iin: item.childIin
                })
            );
            break;
        default:
            break;
    }
};

export const CheckVoucherSK = async (child_iin, queue_type) => {
    try {
        let check = false;
        const checkActiveQueue = await ServiceRequestApi.checkActiveVoucherSK(child_iin, queue_type);

        if (checkActiveQueue.data.status === 'SUCCESS' && checkActiveQueue.data.result.length > 0) {
            for (const item of checkActiveQueue.data.result) {
                await showActiveQueueError(item);
                check = true;
                break;
            }
        }
        const hasContingentSK = await ServiceRequestApi.getContingentCheckSK(child_iin);

      if (hasContingentSK.data.status === 'SUCCESS' && hasContingentSK.data.result.length > 0) {
        const item = hasContingentSK.data.result[0];
        if (
          item.contingentStatus === 'VISITS_SECTION' &&
          item.voucherType === 'TARGETED'
        ) {
          Notice.error(i18next.t('serviceRequest_check_in_queue_err7'));
          check = true;
        } else {
          showContingentError(item);
          check = true;
        }
      }
        const isActiveQueueEmpty = checkActiveQueue.data.status === 'SUCCESS' && checkActiveQueue.data.result.length === 0;
        const isContingentEmpty = hasContingentSK.data.status === 'SUCCESS' && hasContingentSK.data.result.length === 0;

        if (!check && !(isActiveQueueEmpty && isContingentEmpty)) {
            Notice.error(i18next.t('serviceRequest_queue_type_check_req_err'));
        }

        return check;
    } catch (e) {
        handleError(e, i18next.t('gbdflButton_searchFailed'));
        return false;
    }
};

